import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';

const styles = () => {
	return {
		spacing: {
			paddingTop: 2,
			height: 30,
		},
		largeFont: {
			fontSize: 18,
		},
		mobileFont: {
			fontSize: '110%',
		},
		normalFont: {},
		smallFont: {
			fontSize: 14,
			marginLeft: -5,
		},
	};
};

class FormCheckbox extends PureComponent {
	render() {
		const {
			label,
			checked,
			path,
			showLargeFont,
			showSmallFont,
			showMobileFont,
			gridProps,
			onChange,
			classes,
			required,
			hasError,
			disabled,
			helpText,
			fullWidth = true,
			formControlStyle,
		} = this.props;

		const _onChange = (event) => {
			onChange(event.target.checked, path);
		};

		let labelClass = showLargeFont ? 'largeFont' : 'normalFont';
		labelClass = showSmallFont ? 'smallFont' : labelClass;
		labelClass = showMobileFont ? 'mobileFont' : labelClass;

		const content = (
			<FormControl
				style={formControlStyle}
				required={required}
				fullWidth={fullWidth}
				error={hasError}
				disabled={disabled}
			>
				<FormControlLabel
					label={label}
					classes={{ root: classes.spacing, label: classes[labelClass] }}
					control={<Checkbox color="primary" checked={checked} onChange={_onChange} />}
				/>
				{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
			</FormControl>
		);

		if (gridProps) {
			_.defaults(gridProps, { xs: 12 });
			return (
				<Grid item {...gridProps}>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FormCheckbox.propTypes = {
	label: PropTypes.string.isRequired,
	path: PropTypes.string.isRequired,
	checked: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
	classes: PropTypes.object,
	gridProps: PropTypes.object,
	showLargeFont: PropTypes.bool,
	showSmallFont: PropTypes.bool,
	formControlStyle: PropTypes.object,

	error: PropTypes.string,
	helpText: PropTypes.string,
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	fullWidth: PropTypes.bool,
};

export default _.flow([withStyles(styles)])(FormCheckbox);
